import { DataContext } from "@/types";
import { Data } from "../Data";

export class JobSelectorList extends Data {
  static instance: any = null;
  jobs: any;
  attributes: any;

  constructor(options: any) {
    super({
      api:
        (options.groupId ? "/MyGroup/" + options.groupId + "/GetJobs" : "/Teams/GetJobs") +
        "?searchText=" +
        options.search,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });
  }

  onDataReceived(data: any) {
    this.jobs = data.jobs;
  }

  static getJobSelectorList(context: DataContext, search: string, groupId?: string): Promise<JobSelectorList> {
    return new Promise((resolve, reject) => {
      if (JobSelectorList.instance && search === "") resolve(JobSelectorList.instance);
      else
        JobSelectorList.instance = new JobSelectorList({
          resolve,
          reject,
          search,
          context,
          groupId
        });
    });
  }

  findMatch(attr: any) {
    return this.attributes.find((a: any) => a.name === attr);
  }
}
